import React from "react";

const GiftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="gift_icon"
      data-name="gift"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 5.83335H15.6592C15.7815 5.42817 15.8402 5.00651 15.8334 4.58335C15.8334 2.97502 14.5251 1.66669 12.9167 1.66669C11.5651 1.66669 10.6626 2.90169 10.0801 4.23752C9.50591 2.97502 8.55758 1.66669 7.08342 1.66669C5.47508 1.66669 4.16675 2.97502 4.16675 4.58335C4.16675 5.08002 4.23258 5.49085 4.34091 5.83335H3.33341C2.41425 5.83335 1.66675 6.58085 1.66675 7.50002V9.16669C1.66675 10.0859 2.41425 10.8334 3.33341 10.8334V16.6667C3.33341 17.5859 4.08091 18.3334 5.00008 18.3334H15.0001C15.9192 18.3334 16.6667 17.5859 16.6667 16.6667V10.8334C17.5859 10.8334 18.3334 10.0859 18.3334 9.16669V7.50002C18.3334 6.58085 17.5859 5.83335 16.6667 5.83335ZM12.9167 3.33335C13.6059 3.33335 14.1667 3.89419 14.1667 4.58335C14.1667 5.83335 13.6451 5.83335 13.3334 5.83335H11.2684C11.6942 4.52002 12.3126 3.33335 12.9167 3.33335ZM5.83342 4.58335C5.83342 3.89419 6.39425 3.33335 7.08342 3.33335C7.82341 3.33335 8.51175 4.60419 8.91508 5.83335H6.66675C6.35508 5.83335 5.83342 5.83335 5.83342 4.58335ZM3.33341 7.50002H9.16675V9.16669H3.33341V7.50002ZM5.00008 16.6667V10.8334H9.16675V16.6667H5.00008ZM15.0001 16.6667H10.8334V10.8334H15.0001V16.6667ZM10.8334 9.16669V7.57085L10.8476 7.50002H16.6667L16.6676 9.16669H10.8334Z"
        fill={props.fill || "#0E426D"}
      />
    </svg>
  );
};

export default GiftIcon;
